<div class="companies-content">
  <div class="companies-summary">
    <i class="fa-solid fa-building" aria-hidden="true"></i>
    <span>{{ companies().length }} empresas asociadas{{ planName ? ' a ' + planName : '' }}</span>
  </div>

  @if (loading()) {
    <div class="companies-state">
      <app-loading label="Cargando empresas..."></app-loading>
    </div>
  } @else if (loadError()) {
    <div class="companies-state" role="alert">
      <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
      <h3>{{ loadError() }}</h3>
      <app-button variant="primary" (clicked)="loadCompanies()">Reintentar</app-button>
    </div>
  } @else if (companies().length === 0) {
    <div class="companies-state">
      <i class="fa-solid fa-building" aria-hidden="true"></i>
      <h3>No hay empresas suscritas a este plan.</h3>
    </div>
  } @else {
    <div class="companies-table-wrapper">
      <table aria-label="Lista de empresas suscritas">
        <thead>
          <tr>
            <th>Empresa</th>
            <th>Identificación</th>
            <th>Estado</th>
            <th>Suscripción</th>
            <th>Usuarios</th>
          </tr>
        </thead>
        <tbody>
          @for (company of companies(); track company.empresaId) {
            <tr>
              <td>
                <strong>{{ company.razonSocial }}</strong>
                @if (!company.estaActiva) {
                  <small>Empresa inactiva</small>
                }
              </td>
              <td>{{ company.identificacionFiscal }}</td>
              <td>
                <span class="status" [class.inactive]="company.estadoSuscripcion !== 'ACTIVA'">
                  {{ company.estadoSuscripcion }}
                </span>
              </td>
              <td>{{ company.fechaInicio | date: 'dd/MM/yyyy' }}</td>
              <td>{{ company.usuarios }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <div class="companies-cards" aria-label="Empresas suscritas">
      @for (company of companies(); track company.empresaId) {
        <article class="company-card">
          <div class="company-card-header">
            <div>
              <strong>{{ company.razonSocial }}</strong>
              @if (!company.estaActiva) {
                <small>Empresa inactiva</small>
              }
            </div>
            <span class="status" [class.inactive]="company.estadoSuscripcion !== 'ACTIVA'">
              {{ company.estadoSuscripcion }}
            </span>
          </div>
          <dl class="company-card-details">
            <div>
              <dt>Identificación</dt>
              <dd>{{ company.identificacionFiscal }}</dd>
            </div>
            <div>
              <dt>Suscripción</dt>
              <dd>{{ company.fechaInicio | date: 'dd/MM/yyyy' }}</dd>
            </div>
            <div>
              <dt>Usuarios</dt>
              <dd>{{ company.usuarios }}</dd>
            </div>
          </dl>
        </article>
      }
    </div>
  }
</div>
